import { ApiType } from "@gymflow/common";
import { useQuery, UseQueryOptions } from "@tanstack/react-query";

import { clubAsPublicQueryKeys } from "./clubAsPublicQueryKeys";

export function useClubHostedPagesSettingsAsPublic(
  {
    api,
    clubId,
  }: {
    api: ApiType;
    clubId: number;
  },
  opts?: Omit<
    UseQueryOptions<
      | Awaited<ReturnType<ApiType["public"]["clubApi"]["settings"]>>["data"]
      | null
    >,
    "queryKey"
  >,
) {
  return useQuery({
    queryKey: clubAsPublicQueryKeys.hostedPagesSettings(clubId),
    queryFn: async () => {
      return (await api.public.clubApi.settings()).data;
    },
    enabled: !!clubId,
    placeholderData: null,
    ...opts,
  });
}
